// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"111c2002","239":"fe726e06","359":"a1a7d2d2","453":"4bcec737","455":"06bea333","726":"63452396","977":"d0a2303e"}[chunkId] + ".chunk.js";
};